import { render, staticRenderFns } from "./EventWorkflowTable.vue?vue&type=template&id=776f0598"
import script from "./EventWorkflowTable.js?vue&type=script&lang=js&external"
export * from "./EventWorkflowTable.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports